import { Injectable } from '@angular/core';
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {UploadService} from "./upload.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";

@Injectable({
  providedIn: 'root'
})
export class DepartmentService  extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,
              private fileUploadService: UploadService) {
    super(http, alertService, globalService);
  }
  get(data): Observable<any> {
    return this.getRequest(AppUrl.DEPARTMENT(), data);
  }
  create(data): Observable<any> {
    return this.postRequest(AppUrl.DEPARTMENT(), data);
  }
  updateStatus(unique_id, data): Observable<any> {
    return this.putRequest(AppUrl.DEPARTMENT_STATUS(unique_id), data);
  }
  detail(unique_id): Observable<any> {
    return this.getRequest(AppUrl.DEPARTMENT(unique_id));
  }
  update(unique_id, data): Observable<any> {
    return this.putRequest(AppUrl.DEPARTMENT(unique_id), data);
  }
}
